// The draw beat's prompt: an eyebrow naming the task over the keyword the
// learner draws from. Shared with the landing's draw-beat specimen so the
// two never drift.
export function DrawPrompt({ keyword }: { keyword: string }) {
    return (
        <div className="flex flex-col items-center gap-1.5">
            <span className="font-serif text-xs tracking-[0.22em] text-muted-fg uppercase">
                draw it from the keyword
            </span>
            <span className="font-serif text-2xl text-ink">{keyword}</span>
        </div>
    )
}
